// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"b9cb4f5d","590":"e3b24555","746":"f1f557ac","824":"0ebb18e9"}[chunkId] + ".chunk.js";
};